angular
  .module('ui-ng-feature')
  .factory('phxFeatureDelegateConstant', [
    '$compile',
    'phxFeatureDatastore',
    'ngIfDirective',
    function ($compile, phxFeatureDatastore, ngIfDirective) {
      /**
       * consistent configuration lookup
       */
      const getFeatureConfiguration = (scope, element, attrs, event, configuration) => {
        return configuration[attrs.phxFeature];
      };

      /**
       * apply `include` property with a dynamic `ng-if`
       */
      const applyInclude = (scope, element, attrs, event, featureConfiguration) => {
        if (!_.isBoolean(featureConfiguration.include)) {
          return;
        }

        element.css('display', featureConfiguration.include !== false ? 'initial' : 'none');
      };

      /**
       * append html content as a dynamic angular content snippet
       */
      const applyAppendHTML = (scope, element, attrs, event, featureConfiguration) => {
        var angularElement;

        if (!_.isString(featureConfiguration.appendHTML)) {
          return;
        }

        if (!_.isUndefined(element.attr('feature-appended-html'))) {
          return;
        }

        element.attr('feature-appended-html', 'true');
        angularElement = $compile(featureConfiguration.appendHTML)(scope);
        element.append(angularElement);
      };

      const applyAssignContent = (scope, element, attrs, event, featureConfiguration) => {
        if (!_.isString(featureConfiguration.assignContent)) {
          return;
        }

        element.html(featureConfiguration.assignContent);
      };

      const isConfigurationValid = (featureConfiguration) => {
        return (
          !_.isEmpty(featureConfiguration) &&
          !_.includes(['appendHTML', 'assignContent', 'include', 'if'], featureConfiguration)
        );
      };

      return {
        uniqueComponent: 'ui-ng-feature',
        vocabulary: {
          refreshFeatures: function refreshFeatures(scope, element, attrs, event) {
            var configuration = phxFeatureDatastore.store;
            var featureConfiguration = getFeatureConfiguration(scope, element, attrs, event, configuration);

            if (!featureConfiguration) {
              return;
            }

            applyInclude(scope, element, attrs, event, featureConfiguration);
            applyAssignContent(scope, element, attrs, event, featureConfiguration);
            applyAppendHTML(scope, element, attrs, event, featureConfiguration);
          }
        }
      };
    }
  ])
  .directive('phxFeature', [
    'DelegateResponder',
    'phxFeatureDelegateConstant',
    function phxFeature(DelegateResponder, phxFeatureDelegateConstant) {
      return {
        replace: false,
        restrict: 'A',
        scope: false,
        compile: () =>
          DelegateResponder(phxFeatureDelegateConstant, function (scope, element, attrs) {
            scope.refreshFeatures();
          })
      };
    }
  ])
  .service('phxFeature', [
    'DelegateController',
    'phxFeatureDelegateConstant',
    function phxFeatureDelegate(DelegateController, phxFeatureDelegateConstant) {
      DelegateController(this, phxFeatureDelegateConstant);
    }
  ])
  .directive('phxFeatureIf', [
    'ngIfDirective',
    'phxFeatureDatastore',
    function phxFeatureIf(ngIfDirective, phxFeatureDatastore) {
      var ngIf = ngIfDirective[0];
      return {
        transclude: ngIf.transclude,
        priority: ngIf.priority - 1,
        terminal: ngIf.terminal,
        restrict: ngIf.restrict,
        link: function (scope, element, attrs) {
          const featureConfiguration = phxFeatureDatastore.store[attrs.phxFeature];
          // find the initial ng-if attribute
          let initialNgIf = attrs.ngIf,
            ifEvaluator;
          // if it exists, evaluates ngIf && featureConfiguration.if
          if (initialNgIf) {
            ifEvaluator = function () {
              return scope.$eval(initialNgIf) && featureConfiguration.if;
            };
          } else {
            // if there's no ng-if, process normally
            ifEvaluator = function () {
              return featureConfiguration.if;
            };
          }
          attrs.ngIf = ifEvaluator;
          ngIf.link.apply(ngIf, arguments);
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-feature/src/component.es.js